export const CONTACT = {
    name: "Guillermo Figueroa Mesa",
    title: "Problem solver",
    location: "Austin, Texas",
    whatsappNumber: "+1 737 354 0688",
    whatsappHref:
        "https://wa.me/17373540688?text=Hi%20Guillermo%2C%20I%20found%20gfirem.com%20and%20I%27d%20like%20to%20talk%20about%20a%20project.",
    calendlyHref: "https://calendly.com/scalater/discovery-call",
    email: "gfirem@gmail.com",
    emailHref: "mailto:gfirem@gmail.com",
    instagram: "#",
    linkedin: "https://www.linkedin.com/in/gfirem/",
    github: "https://github.com/gfirem",
};
